import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { TaxInvoiceSubmissionType } from 'features/AdsManagement/services/taxInvoice'

export const SLICE_NAME = 'adsEfaktur'

export type ListFetchStatusType = 'idle' | 'loading' | 'success' | 'error'

type PaginationStateType = {
  next_cursor: string
  prev_cursor: string
}

interface AdsEfakturStateInterface {
  isLoading: boolean
  isUploading: boolean
  submissions: TaxInvoiceSubmissionType[]
  pagination: PaginationStateType
  listFetchStatus: ListFetchStatusType
}

const initialState: AdsEfakturStateInterface = {
  isLoading: false,
  isUploading: false,
  submissions: [],
  pagination: { next_cursor: '', prev_cursor: '' },
  listFetchStatus: 'idle',
}

const adsEfakturSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsUploading: (state, action: PayloadAction<boolean>) => {
      state.isUploading = action.payload
    },
    setSubmissions: (state, action: PayloadAction<TaxInvoiceSubmissionType[]>) => {
      state.submissions = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationStateType>) => {
      state.pagination = action.payload
    },
    setListFetchStatus: (state, action: PayloadAction<ListFetchStatusType>) => {
      state.listFetchStatus = action.payload
    },
  },
})

export const { setIsLoading, setIsUploading, setSubmissions, setPagination, setListFetchStatus } =
  adsEfakturSlice.actions

export default adsEfakturSlice.reducer
